export default "__VITE_ASSET__B$HOfGjW__"